<template>
	<div class="index">
		<div class="qdCard">
			<!-- 签到按钮 -->
			<div class="mobQDbtn">
			</div>
			<!-- 查看年会流程 -->
			<div class="mobQDbottom">
				<span @click="LinkImg()">
				</span>
				<span @click="succeed(rule)">
				</span>
			</div>
		</div>

		<div class="qdsucceedB" v-if="qdsucceedShow">
			<img src="../assets/img/qdsucceed.png" class="qdsucceed">
		</div>
		<div class="login">
			<van-dialog v-model="show1" confirmButtonText="签到" show-cancel-button :beforeClose="beforeClose">
				<div style="padding: 24px 0 0 0;text-align: center; font-size: 14px; width: 100%;">
					<div>由于您的微信未关联到企业微信</div>
					<div>需要使用企业微信注册的手机号进行签到</div>
				</div>

				<van-cell-group>
					<van-field class='colo' v-model="phone" label="手机号" type="number" required clearable />
					<van-field class='colo' v-model="verifyCode" center clearable label="验证码" placeholder="请输入短信验证码" required>
						<van-button v-show="show" id="sms" slot="button" size="small" type="info" @click='smsbtn'>发送验证码</van-button>
						<van-button v-show="!show" disabled id="sms2" slot="button" size="small" type="info" @click='smsbtn'>{{count}}s</van-button>
					</van-field>
				</van-cell-group>


			</van-dialog>
		</div>


	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		mapState,
		mapMutations
	} from 'vuex';
	import {
		Dialog,
		Field,
		Notify
	} from 'vant';

	Vue.use(Dialog).use(Field).use(Notify);


	export default {
		name: 'index',
		data() {
			return {
				txt: '发送验证码',
				show: true,
				count: '',
				timer: null,
				phone: "",
				verifyCode: "",
				rule: {
					name: '签到记录',
					index: 1,
					router: "/rule",
				},
				popup: {
					name: '屏幕互动',
					index: 2,
					router: "/popup",
				},
				qdsucceedShow: false,
				show1: false
			}
		},
		methods: {
			...mapMutations(['navChange']),
			succeed(data) {
				this.routerChange(data)
			},
			routerChange(data) {
				// this.$router.push(data.router)
				// this.navChange(data)
				window.location.replace("https://party.blueiec.com/userOpen/index.html#/rule")
			},
			LinkImg() {
				window.location.href = 'https://live.photoplus.cn/activity/live/14459494'
			},
			getToken(variable) {
				var query = window.location.search.substring(1);
				var vars = query.split("&");
				for (var i = 0; i < vars.length; i++) {
					var pair = vars[i].split("=");
					if (pair[0] == variable) {
						return pair[1];
					}
				}
				return (false);
			},
			smsbtn() {
				const TIME_COUNT = 60;
				if (!this.timer) {
					this.count = TIME_COUNT;
					this.show = false;
					this.timer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.count--;
						} else {
							this.show = true;
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 1000)
				}
				this.axios.get('https://party.blueiec.com/annual-meeting/qy/verifyCode?phone=' + this.phone)
					.then(res => {
						console.log(res)
						Notify({
							type: res.data.code == 0 ? 'success' : 'danger',
							message: res.data.msg
						})
					})
			},
			beforeClose(action, done) {
				var that = this
				if (action === 'confirm') {
					this.axios.get('https://party.blueiec.com/annual-meeting/qy/phoneLogin?phone=' + this.phone + '&verifyCode=' +
							this.verifyCode + '&activityId=1')
						.then(res => {
							console.log(res)
							if (res.data.code == 0) {
								Notify({
									type: 'success',
									message: res.data.msg
								})
								localStorage.setItem("userid", res.data.user.userid); //用户id
								localStorage.setItem("username", res.data.user.name); //获取用户头像
								localStorage.setItem("signTime", res.data.user.signTime); //获取用户头像
								this.qdsucceedShow = true;
								setTimeout(() => {
									this.qdsucceedShow = false;
								}, 1500);
								done()
							} else {
								Notify({
									type: 'danger',
									message: res.data.msg
								})
								done(false)
								this.verifyCode = ''
							}
						})
				} else {
					done();
				}
			},
		},
		mounted() {
			// var code = this.getToken('code');
			// // alert('用户ID'+localStorage.getItem("userid"))
			// if (code) {
			// 	if (!localStorage.getItem("userid")) {
			// 		this.axios.get('https://party.blueiec.com/annual-meeting/qy/sign?code=' + code + '&activityId=1')
			// 			.then(res => {
			// 				// alert(JSON.stringify(res.data))
			// 				if (res.data.code == 0) {
			// 					localStorage.setItem("userid", res.data.user.userid); //用户id
			// 					localStorage.setItem("username", res.data.user.name); //获取用户头像
			// 					localStorage.setItem("signTime", res.data.user.signTime); //获取用户头像
			// 					this.qdsucceedShow = true;
			// 					setTimeout(() => {
			// 						this.qdsucceedShow = false;
			// 					}, 1500);
			// 				} else {
			// 					this.show1 = true;
			// 				}
			// 			})
			// 	}

			// } else {
			// 	this.axios.get('https://party.blueiec.com/annual-meeting/qy/getUserCode')
			// 		.then(res => {
			// 			if (res.data.url) {
			// 				window.location.replace(res.data.url)
			// 			}
			// 		})
			// }
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.index {
		display: block;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: url('../assets/img/mobBackground.jpg') repeat center;
		background-size: 100% auto;
		z-index: 101;
	}

	.qdCard {
		display: block;
		height: 95%;
		background: url('../assets/img/mobCard.jpg') no-repeat center;
		background-size: auto 100%;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}

	.qdsucceedB {
		display: block;
		height: 100vh;
		background: rgba(0, 0, 0, 0.7);
		background-size: auto 100%;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;

		animation: qdCg 0.6s forwards;
		-moz-animation: qdCg 0.6s forwards;
		/* Firefox */
		-webkit-animation: qdCg 0.6s forwards;
		/* Safari 和 Chrome */
		-o-animation: qdCg 0.6s forwards;
		/* Opera */
	}

	.login .van-field__label {
		width: 60px !important;
	}

	.login .van-button {
		background: #fff !important;
	}

	.login .colo {
		color: #000 !important;
	}

	#sms {
		background: #1989fa !important;
	}

	#sms2 {
		background: #1989fa !important;
	}

	.login .van-cell-group {
		margin-top: 0.4rem;
	}

	@keyframes qdCg {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	@-moz-keyframes qdCg

	/* Firefox */
		{
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	@-webkit-keyframes qdCg

	/* Safari 和 Chrome */
		{
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	@-o-keyframes qdCg

	/* Opera */
		{
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	.qdsucceed {
		display: block;
		height: 40%;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;

		animation: qdCgRen 0.6s forwards;
		-moz-animation: qdCgRen 0.6s forwards;
		/* Firefox */
		-webkit-animation: qdCgRen 0.6s forwards;
		/* Safari 和 Chrome */
		-o-animation: qdCgRen 0.6s forwards;
		/* Opera */
	}

	@keyframes qdCgRen {
		from {
			height: 10%;
		}

		to {
			height: 40%;
		}
	}

	@-moz-keyframes qdCgRen

	/* Firefox */
		{
		from {
			height: 10%;
		}

		to {
			height: 40%;
		}
	}

	@-webkit-keyframes qdCgRen

	/* Safari 和 Chrome */
		{
		from {
			height: 10%;
		}

		to {
			height: 40%;
		}
	}

	@-o-keyframes qdCgRen

	/* Opera */
		{
		from {
			height: 10%;
		}

		to {
			height: 40%;
		}
	}

	.mobQDbtn {
		display: block;
		height: 18%;
		background: url('../assets/img/mobQDbtn.png') no-repeat center;
		background-size: auto 100%;
		position: absolute;
		top: 30%;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;

	}

	.mobQDbottom {
		display: block;
		height: 14%;
		background: url('../assets/img/mobQDbottom.png') no-repeat center;
		background-size: auto 100%;
		position: absolute;
		top: 75%;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;

		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: center;
		align-items: center;
		align-content: center;
	}

	.mobQDbottom span {
		display: block;
		width: 50%;
		height: 100%;
		/* top: 30%; */
	}
</style>



// WEBPACK FOOTER //
// src/components/index.vue